// extracted by mini-css-extract-plugin
export default {"container":"QGLpYiSrAvhaSG0M44ls"};